export const compareDate = (date1: Date, date2: Date) => {
  if (date1.toISOString() < date2.toISOString()) return -1;
  if (date1.toISOString() > date2.toISOString()) return 1;
  return 0;
};
